'use client';

import { MutableRefObject, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Vivus from 'vivus';
import styles from './LotteryPrizeStaging.module.scss';
import { montserrat } from '@/lib/font';

// 公開したいメソッドの定義
export type LotteryPrizeStagingHandler = {
  play(playId: number): void;
};

function LotteryPrizeStaging({
  id,
  stagingRank,
  stagingText,
  customRef,
}: {
  id: number;
  stagingRank: string;
  stagingText: string;
  customRef: MutableRefObject<LotteryPrizeStagingHandler | undefined>;
}) {
  const [isSp, setIsSp] = useState(false);
  const rankText = () => {
    switch (stagingRank) {
      case '1':
        return 'rainbow';
      case '2':
        return 'gold';
      default:
        return 'silver';
    }
  };
  const targetRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(customRef, () => ({
    play: (playId: number) => {
      const stroke = new Vivus(`mask-${playId}`, {
        start: 'manual',
        type: 'scenario-sync',
        duration: 50,
        forceRender: false,
        animTimingFunction: Vivus.EASE_IN,
      });
      stroke.play();
    },
  }));

  useEffect(() => {
    const innerWidth = window ? window.innerWidth : 0;
    setIsSp(innerWidth < 600);
  }, []);

  return (
    <div className={styles.componentStyle} ref={targetRef}>
      {isSp ? (
        <>
          <svg
            id={`mask-${id}`}
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            viewBox='0 0 695 157'
            xmlSpace='preserve'
            className={styles.mask}
          >
            <image
              xmlnsXlink='http://www.w3.org/1999/xlink'
              xlinkHref={`/staging/sp/prize_${rankText()}.png`}
              width='695'
              height='157'
              mask={`url("#clipmask-${id}")`}
            />
            <mask id={`clipmask-${id}`} maskUnits='objectBoundingBox'>
              <path
                className={styles.st0}
                d='M104.71,143.54s-9.09,4.99-25.01,4.99S9,136.72,9,78.76,60.54,9,78.76,9s69.76,15.81,69.76,69.76c0,24.55-4.99,25.94-4.99,25.94H686.61'
              />
              <line className={styles.st0} x1='144.18' y1='104.01' x2='683.07' y2='104.01' />
            </mask>
          </svg>
          <p className={styles.prizeStagingText}>
            <span className={montserrat.className}>{stagingText}</span>
            <small>賞</small>
          </p>
        </>
      ) : (
        <>
          <svg
            id={`mask-${id}`}
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            viewBox='0 0 1176 150'
            xmlSpace='preserve'
            className={styles.mask}
          >
            <image
              xmlnsXlink='http://www.w3.org/1999/xlink'
              xlinkHref={`/staging/pc/prize_${rankText()}.png`}
              width='1176'
              height='150'
              mask={`url("#clipmask-${id}")`}
            />
            <mask id={`clipmask-${id}`} maskUnits='objectBoundingBox'>
              <path
                className={styles.st0}
                d='M104.71,143.54s-9.09,4.99-25.01,4.99S9,136.72,9,78.76,60.54,9,78.76,9s69.76,15.81,69.76,69.76c0,24.55-4.99,25.94-4.99,25.94H1173.39'
              />
              <line className={styles.st0} x1='144.18' y1='104.01' x2='683.07' y2='104.01' />
            </mask>
          </svg>
          <p className={styles.prizeStagingText}>
            <span className={montserrat.className}>{stagingText}</span>
            <small>賞</small>
          </p>
        </>
      )}
    </div>
  );
}

export default LotteryPrizeStaging;
